import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateWorkerReportsPagination } from '../../../store/actions/reports/reports_action';
import { Container, Grid, makeStyles } from '@material-ui/core';
import DatePicker from '../../ui_components/date_picker';
import ReportsTable from './worker_reports_table';
import { isValid } from 'date-fns';
import CheckboxesTags from '../../ui_components/checkboxes_tags';
import { reduceArrayOfOptions } from '../../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2),
        maxWidth:2000
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

const WorkerReportsList = ({ workerReports }) => {
    const { container } = useStyles();
    const [year, setYear] = useState(new Date());
    //default type doctor
    const [type, setType] = useState(1);
    const dispatch = useDispatch();

    const { filters } = workerReports;

    useEffect(() => {
        if (filters.year) {
            setYear(filters.year);
        }
    }, []);

    const handleYearChange = (e) => {
        const year = e;
        if (isValid(year)) {
            setYear(year);
            dispatch(updateWorkerReportsPagination({...workerReports, page: 0, filters: { year }}));
        }
    }

    const handleTypesChange = (e, values) => {
        if(values.length)
            setType(values[0].id);
        else
            setType(1);
        dispatch(updateWorkerReportsPagination({ ...workerReports, page: 0, filters: { ...filters, types: reduceArrayOfOptions(values) }}));
    }

    return (
        <Container className={container}>
            <Grid container item xs={12} justify="center" alignItems="flex-start" spacing={2}>
                <Grid item xs={6}>
                    <CheckboxesTags
                        value={filters.types}
                        limitTags={1}
                        onChange={handleTypesChange}
                        options={[
                            { id: 1, name: 'Doktor'},
                            { id: 2, name: 'Tehničar' },
                            { id: 3, name: 'Osiguravajuća kuća' }
                        ]}
                        placeholder='Tipovi radnika'
                        label='Tipovi radnika'
                        loadingText='Učitavanje'
                        maxWidth="auto"
                    />
                </Grid>
                <Grid item xs={6}>
                    <DatePicker
                        name="year"
                        value={year}
                        label="Godina"
                        placeholder="Godina"
                        onChange={handleYearChange}
                        views={['year']}
                    />
                </Grid>
            </Grid>
            <ReportsTable 
                type={type || 1}
            />
        </Container>
    )
}

WorkerReportsList.propTypes = {
    workerReports: PropTypes.object
}

const mapStateToProps = (state) => ({
    workerReports: state.workerReports
});

export default connect(mapStateToProps)(WorkerReportsList);
